var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCw8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8cde3;\n        stroke: #9e1f63;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #9e1f63;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.64,16.27c0-1.04,.28-2.02,.85-2.95,.57-.92,1.4-1.66,2.5-2.21,1.1-.55,2.38-.83,3.85-.83,1.24,0,2.33,.16,3.27,.48,.94,.32,1.72,.77,2.34,1.34,.62,.57,1.09,1.21,1.39,1.92,.3,.71,.45,1.47,.45,2.27,0,1.02-.26,1.93-.79,2.73-.53,.8-1.31,1.46-2.35,1.97,.88,.34,1.62,.79,2.2,1.35,.58,.56,1.02,1.2,1.32,1.94s.45,1.55,.45,2.45c0,1.31-.32,2.5-.95,3.57-.64,1.07-1.57,1.9-2.8,2.51-1.23,.6-2.68,.91-4.34,.91s-3.21-.3-4.44-.91c-1.23-.6-2.16-1.43-2.78-2.49-.62-1.06-.94-2.24-.94-3.55,0-2.8,1.32-4.72,3.97-5.77-2.14-1-3.2-2.58-3.2-4.73Zm11.2,10.34c0-.81-.17-1.52-.5-2.12-.33-.6-.8-1.07-1.41-1.39-.6-.32-1.28-.48-2.03-.48-1.06,0-1.95,.35-2.67,1.06-.72,.71-1.08,1.7-1.08,2.97,0,.81,.17,1.53,.51,2.15,.34,.62,.8,1.1,1.38,1.44,.58,.34,1.23,.51,1.95,.51s1.38-.17,1.97-.52c.58-.34,1.04-.83,1.38-1.45,.33-.62,.5-1.34,.5-2.16Zm-3.91-13.34c-.98,0-1.77,.3-2.37,.91-.6,.61-.9,1.39-.9,2.35,0,.89,.31,1.62,.92,2.21,.61,.59,1.41,.88,2.38,.88,.49,0,.93-.08,1.34-.23,.4-.16,.74-.37,1.03-.65,.29-.28,.51-.6,.66-.98,.16-.38,.23-.8,.23-1.26,0-.61-.14-1.17-.41-1.66-.28-.49-.66-.88-1.16-1.16s-1.07-.42-1.72-.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw8);
export default __webpack_public_path__ + "static/media/CW8.9c6a954cc7fa597203fa6c349a802b3d.svg";
export { ForwardRef as ReactComponent };